import { useEffect, useState, useCallback } from 'react';
import { Card, Table, Space, Button, Tag, message, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getLicenseListAPI, updateLicenseAPI } from '@/apis/license';

// 秒级时间戳格式化
function formatTs(ts){
  if(!ts) return '-';
  // 后端给的是秒级
  return dayjs.unix(ts).format('YYYY-MM-DD HH:mm:ss');
}

const sourceColor = (s)=>{
  switch(s){
    case 'design': return 'geekblue';
    case 'execute': return 'green';
    case 'manager': return 'gold';
    default: return 'default';
  }
};

const LicenseList = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState([]);

  const fetchList = useCallback(async ()=>{
    setLoading(true);
    try {
      const res = await getLicenseListAPI();
      if(res.code===0 && Array.isArray(res.data)) setData(res.data);
      else message.error(res.msg || '获取列表失败');
    } catch(e){
      console.error(e);
      message.error('获取列表失败');
    } finally { setLoading(false); }
  },[]);

  useEffect(()=>{ fetchList(); }, [fetchList]);

  const renewOneYear = async (record)=>{
    const newCanUseDate = Math.floor(Date.now()/1000) + 365*24*3600; // 增加一年（不考虑闰秒）
    try {
      await updateLicenseAPI({ id: record.id, canUseDate: newCanUseDate });
      message.success('续期成功');
      fetchList();
    } catch(e){ message.error('续期失败'); }
  };

  const disableNow = async (record)=>{
    const now = Math.floor(Date.now()/1000);
    try {
      await updateLicenseAPI({ id: record.id, canUseDate: now });
      message.success('已禁用');
      fetchList();
    } catch(e){ message.error('禁用失败'); }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 60 },
    { title: '类型', dataIndex: 'appSource', render: v=> <Tag color={sourceColor(v)}>{v}</Tag> },
    { title: 'License', dataIndex: 'license', ellipsis: true },
    { title: '有效期至', dataIndex: 'canUseDate', render: v=> formatTs(v) },
    { title: '创建时间', dataIndex: 'createdAt', render: v=> v? dayjs(v).format('YYYY-MM-DD HH:mm:ss'):'-' },
    { title: '更新时间', dataIndex: 'updatedAt', render: v=> v? dayjs(v).format('YYYY-MM-DD HH:mm:ss'):'-' },
    { title: '最后检查时间', dataIndex: 'lastCheckAt', render: v=> v? dayjs(v).format('YYYY-MM-DD HH:mm:ss'):'-' },
    { title: '备注', dataIndex: 'info', ellipsis: true },
    { title: '操作', key: 'action', width: 200, render: (_, record)=>(
        <Space>
          <Tooltip title="续期一年">
            <Button size="small" onClick={()=>renewOneYear(record)}>续期1年</Button>
          </Tooltip>
          <Tooltip title="立即禁用(有效期设为现在)">
            <Button size="small" danger onClick={()=>disableNow(record)}>禁用</Button>
          </Tooltip>
        </Space>
      ) 
    }
  ];

  return (
    <Card title="许可证列表" extra={<Space><Button type="primary" onClick={()=>navigate('/LicenseAdd')}>新增</Button><Button onClick={fetchList} loading={loading}>刷新</Button></Space>}>
      <Table rowKey="id" loading={loading} dataSource={data} columns={columns} pagination={false} />
    </Card>
  );
};

export default LicenseList;
